import React, { useEffect, useState } from 'react'
import AddButtonPage from '../../../../Components/AddButtonPage/AddButtonPage'
import Newsletter from './Newsletter'
import { useDispatch, useSelector } from 'react-redux';
import actions from '../../../../ReduxStore/actions';
import { toast } from 'react-toastify';

const NewsletterHome = () => {

  const tableData = [
    { campusName: "Cygnusa", newsletterTitle: 'Annual Science Fair' },
    { campusName: "Cygnusa", newsletterTitle: 'Cultural Fest Highlights' },
    { campusName: "Cygnusa", newsletterTitle: 'Tech Talk Series' },
    { campusName: "Cygnusa", newsletterTitle: 'Alumni Meet' }
  ];

  const tableHeadData = ['S.No', 'Campus Name', "Newsletter Title", "Actions"]



  const dispatch = useDispatch();

  const { updateNewsletter } = useSelector(state => state?.updateNewsletter);
  const { deleteNewsletter } = useSelector(state => state?.deleteNewsletter);




  const { NewsletterGetAll } = useSelector(state => state?.NewsletterGetAll);
  console.log(NewsletterGetAll, "NewsletterGetAll")
  const { NewsletterPost } = useSelector(
    (state) => state?.NewsletterPost
  );

  const [rowTableData, setRowTableData] = useState([])
  console.log(rowTableData, "rowTableTAdatatattattat")

  useEffect(() => {
    const fetchData = async () => {

      const data1 = {
        data: {},
        method: "get",
        apiName: `getAllNewsletters`,
      };

      const responseData = await dispatch(actions.NEWSLETTERGETALL(data1));
      console.log(responseData, "responseDataaa")
      // setResponseTableData(responseData?.payload)

    }


    fetchData();

  }, [NewsletterPost,deleteNewsletter,updateNewsletter]);

  useEffect(() => {
    const tempArr = [];

    NewsletterGetAll?.data?.map((data, index) => {
      return tempArr.push({
        id: data?.newsletter_id,
        campusName: data?.campus_name || '--',
        newsLetterTitle: data?.title || '--',


      });
    });
    setRowTableData(tempArr);


  }, [NewsletterGetAll]);
  const handleDeleteById = async (id) => {
    console.log(id, "iddddddddddd")
    const data1 = {
      data: {},
      method: "delete",
      apiName: `deleteNewsletter/${id}`,
    };

    const responseData = await dispatch(actions.DELETENEWSLETTER(data1));
    if (responseData?.payload?.message === "Newsletter deleted successfully.") {
      toast.success(responseData?.payload?.message)

    } else {
      toast.error(responseData?.payload?.message)


    }


  }


  return (
    <div>
      <AddButtonPage addComponent={Newsletter} handleDeleteById={handleDeleteById} title="News Letter" tableData={rowTableData} tableHeadData={tableHeadData} />
    </div>
  )
}

export default NewsletterHome